import { render, staticRenderFns } from "./SlotCreate.vue?vue&type=template&id=0a0b897a&scoped=true&"
import script from "./SlotCreate.vue?vue&type=script&lang=js&"
export * from "./SlotCreate.vue?vue&type=script&lang=js&"
import style0 from "./SlotCreate.vue?vue&type=style&index=0&id=0a0b897a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0b897a",
  null
  
)

export default component.exports